import IndicationsList from './IndicationsList';
export default IndicationsList;
